import { SHOE } from 'app/productDetails/productDetailsConstants';
import { ShoeSizeGuideType } from 'app/commonComponents/shoeSizeGuide/constants';

const kidsSizeCodePattern = /Size_K/;
export const isGroupedSizeSelector = sizes =>
  sizes.findIndex(size => kidsSizeCodePattern.test(size.hybrisSizeCode)) >= 0;

export const isAdultSize = (size, country) => {
  const adultSizes = {
    uk: ['Size_K010', 'Size_K015', 'Size_K020'],
    us: ['Size_K130', 'Size_K135', 'Size_K010', 'Size_K015', 'Size_K020'],
    ca: ['Size_K130', 'Size_K135', 'Size_K010', 'Size_K015', 'Size_K020'],
  };
  return adultSizes[country]?.includes(size.hybrisSizeCode) ?? false;
};

export const getGroupedKidsSize = (sizes, country) => {
  const groupedSize = { kids: [], adult: [] };

  sizes.forEach(size => (isAdultSize(size, country) ? groupedSize.adult.push(size) : groupedSize.kids.push(size)));

  return groupedSize;
};

const genderCodeToType = {
  female: ShoeSizeGuideType.women,
  male: ShoeSizeGuideType.men,
  kids: ShoeSizeGuideType.kids,
};

export const getShoeSizeGuideType = (productType, gender, sizes) => {
  if (productType !== SHOE) {
    return null;
  }

  if (Array.isArray(sizes) && isGroupedSizeSelector(sizes)) {
    return ShoeSizeGuideType.kids;
  }

  return genderCodeToType[gender?.code?.toLowerCase()] || null;
};
